import { render, staticRenderFns } from "./CreateClassOverview.vue?vue&type=template&id=455f56e0&scoped=true&"
import script from "./CreateClassOverview.vue?vue&type=script&lang=js&"
export * from "./CreateClassOverview.vue?vue&type=script&lang=js&"
import style0 from "./CreateClassOverview.vue?vue&type=style&index=0&id=455f56e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f56e0",
  null
  
)

export default component.exports